import { ReportColumnPersonalizationFlags } from '../columnUtils.types';
import {
  SoldTicketReportTableGroupingColumnId,
  SoldTicketReportTableValueColumnId,
} from './soldTicketColumnUtils.types';

export const SOLD_TICKET_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  string,
  Partial<ReportColumnPersonalizationFlags>
> = {
  [SoldTicketReportTableGroupingColumnId.EventDateLocal]: {
    isDateTime: true,
  },
  [SoldTicketReportTableGroupingColumnId.SaleDate]: {
    isDateTime: true,
  },
  [SoldTicketReportTableGroupingColumnId.InHandDate]: {
    isDateTime: true,
  },
  [SoldTicketReportTableGroupingColumnId.LastPaymentDate]: {
    isDateTime: true,
  },
  [SoldTicketReportTableGroupingColumnId.SaleCancellationDate]: {
    isDateTime: true,
  },
  [SoldTicketReportTableGroupingColumnId.FulfillmentDate]: {
    isDateTime: true,
  },
  [SoldTicketReportTableGroupingColumnId.PurchaseOrderDate]: {
    isDateTime: true,
  },
  [SoldTicketReportTableGroupingColumnId.PurchaseOrderCancellationDate]: {
    isDateTime: true,
  },
  [SoldTicketReportTableValueColumnId.UnitNetProceeds]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SoldTicketReportTableValueColumnId.Charges]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SoldTicketReportTableValueColumnId.Credits]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SoldTicketReportTableValueColumnId.OutstandingBalance]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SoldTicketReportTableValueColumnId.PandL]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SoldTicketReportTableValueColumnId.Margin]: {
    isNumeric: true,
    isPercent: true,
  },
  [SoldTicketReportTableValueColumnId.UnitCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SoldTicketReportTableValueColumnId.Quantity]: {
    isNumeric: true,
  },
};
